"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullToUndefined = void 0;
// eslint-disable-next-line @typescript-eslint/ban-types
async function nullToUndefined(value) {
    return (await value) ?? undefined;
}
exports.nullToUndefined = nullToUndefined;
//# sourceMappingURL=null-to-undefined.js.map